// extracted by mini-css-extract-plugin
export default {"displaySettings":"I5ScJU7NI3c0iD0YjVYN__displaySettings___","saveButton":"HyC5gdnplgfQeaEFhgxY__saveButton___"};